function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!
/**
* Highcharts JS v12.1.2 (2024-12-21)
* @module highcharts/modules/no-data-to-display
* @requires highcharts
*
* Plugin for displaying a message when there is no data visible in chart.
*
* (c) 2010-2024 Highsoft AS
* Author: Oystein Moseng
*
* License: www.highcharts.com/license
*/
function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(t._Highcharts, t._Highcharts.AST) : "function" == typeof define && define.amd ? define("highcharts/modules/no-data-to-display", ["highcharts/highcharts"], function (t) {
    return e(t, t.AST);
  }) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["highcharts/modules/no-data-to-display"] = e(t._Highcharts, t._Highcharts.AST) : t.Highcharts = e(t.Highcharts, t.Highcharts.AST);
}("undefined" == typeof window ? this : window, function (t, e) {
  return function () {
    "use strict";

    var a = {
      660: function _(t) {
        t.exports = e;
      },
      944: function _(e) {
        e.exports = t;
      }
    },
        o = {};

    function i(t) {
      var e = o[t];
      if (void 0 !== e) return e.exports;
      var n = o[t] = {
        exports: {}
      };
      return a[t](n, n.exports, i), n.exports;
    }

    i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, {
        a: e
      }), e;
    }, i.d = function (t, e) {
      for (var a in e) {
        i.o(e, a) && !i.o(t, a) && Object.defineProperty(t, a, {
          enumerable: !0,
          get: e[a]
        });
      }
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    };
    var n = {};
    i.d(n, {
      default: function _default() {
        return x;
      }
    });
    var r = i(944),
        s = i.n(r),
        h = i(660),
        d = i.n(h);

    var l = {
      lang: {
        noData: "No data to display"
      },
      noData: {
        attr: {
          zIndex: 1
        },
        position: {
          x: 0,
          y: 0,
          align: "center",
          verticalAlign: "middle"
        },
        style: {
          fontWeight: "bold",
          fontSize: "0.8em",
          color: "#666666"
        }
      }
    },
        _s = s(),
        c = _s.addEvent,
        p = _s.extend,
        f = _s.merge;

    function u() {
      var t = this.series || [],
          e = t.length;

      for (; e--;) {
        if (t[e].hasData() && !t[e].options.isInternal) return !0;
      }

      return this.loadingShown;
    }

    function g() {
      this.noDataLabel && (this.noDataLabel = this.noDataLabel.destroy());
    }

    function D(t) {
      var e = this.options,
          a = t || e && e.lang.noData || "",
          o = e && (e.noData || {});
      this.renderer && (this.noDataLabel || (this.noDataLabel = this.renderer.label(a, 0, 0, void 0, void 0, void 0, o.useHTML, void 0, "no-data").add()), this.styledMode || this.noDataLabel.attr(d().filterUserAttributes(o.attr || {})).css(o.style || {}), this.noDataLabel.align(p(this.noDataLabel.getBBox(), o.position || {}), !1, "plotBox"));
    }

    function b() {
      this.hasData() ? this.hideNoData() : this.showNoData();
    }

    var y = s();
    ({
      compose: function compose(t, e) {
        var a = t.prototype;
        a.showNoData || (a.hasData = u, a.hideNoData = g, a.showNoData = D, c(t, "render", b), f(!0, e, l));
      }
    }).compose(y.Chart, y.defaultOptions);
    var x = s();
    return n.default;
  }();
});